import { memo } from 'react'
import {
  Checkbox as CheckboxMui,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  SxProps,
} from '@mui/material'
import { Text } from '@/components/Data'
import { CheckboxCheckedIcon, CheckboxIcon } from './CheckboxIcon'
import { checkboxStyles as styles } from './Checkbox.style'
import { CheckboxInputProps, CheckboxProps, CheckboxGroupProps } from './Checkbox.types'

function CheckboxInput({ ...props }: CheckboxInputProps) {
  return (
    <CheckboxMui
      disableRipple
      color="default"
      checkedIcon={<CheckboxCheckedIcon />}
      icon={<CheckboxIcon />}
      {...props}
    />
  )
}

function Checkbox({
  label,
  labelProps = {},
  checkboxInputProps = {},
  slotProps = {},
  sx = {},
  onChange,
  ...props
}: CheckboxProps) {
  const { sx: labelSx = {}, ...otherLabelProps } = labelProps
  const { typography = {}, ...otherSlotProps } = slotProps

  return (
    <FormControlLabel
      sx={[styles.formControlLabel, sx] as SxProps}
      label={
        typeof label === 'string' ? (
          <Text sx={[styles.label, labelSx] as SxProps} variant="textSmMedium" {...otherLabelProps}>
            {label}
          </Text>
        ) : (
          label
        )
      }
      control={<CheckboxInput onChange={onChange} {...checkboxInputProps} />}
      slotProps={{
        typography: { sx: styles.labelWrapper, ...typography },
        ...otherSlotProps,
      }}
      {...props}
    />
  )
}

function CheckboxGroup({ title, titleProps = {}, ...props }: CheckboxGroupProps) {
  const { sx: titleSx = {}, ...otherTitleProps } = titleProps
  return (
    <FormControl className="w-100" component="fieldset" variant="standard">
      {title && (
        <FormLabel component="legend">
          <Text
            sx={[styles.groupTitle, titleSx] as SxProps}
            variant="textMdSemibold"
            {...otherTitleProps}>
            {title}
          </Text>
        </FormLabel>
      )}
      <FormGroup {...props} />
    </FormControl>
  )
}

const MemoCheckboxInput = memo(CheckboxInput)
const MemoCheckboxGroup = memo(CheckboxGroup)
export { MemoCheckboxInput as CheckboxInput, MemoCheckboxGroup as CheckboxGroup }
export default memo(Checkbox)
